import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { requestEndpoints } from "../apis";

const { 
  CREATE_REQUEST_API, 
  GET_MY_REQUESTS_API, 
  REQUEST_BASE_API, 
  ADMIN_GET_ALL_REQUESTS_API, 
  ADMIN_REQUEST_BASE_API 
} = requestEndpoints;

const getAuthHeader = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  return { Authorization: `Bearer ${token}` };
};

// =========================================================
// STUDENT: CREATE A NEW REQUEST
// =========================================================
export async function createRequest(requestData) {
  const toastId = toast.loading("Submitting request...");
  try {
    const response = await apiConnector(
      "POST",
      CREATE_REQUEST_API,
      requestData, // e.g., { type: "subject", title: "Add Math", description: "..." }
      getAuthHeader()
    );

    toast.success("Request submitted successfully!");
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to submit request");
    return null;
  } finally {
    toast.dismiss(toastId);
  }
}

// =========================================================
// STUDENT: GET MY REQUESTS
// =========================================================
export async function getMyRequests() {
  try {
    const response = await apiConnector(
      "GET",
      GET_MY_REQUESTS_API,
      null,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    toast.error("Failed to fetch your requests");
    return null;
  }
}

// =========================================================
// STUDENT: UPDATE PENDING REQUEST
// =========================================================
export async function updateRequest(requestId, updatedData) {
  const toastId = toast.loading("Updating request...");
  try {
    const response = await apiConnector(
      "PUT",
      `${REQUEST_BASE_API}/${requestId}`,
      updatedData,
      getAuthHeader()
    );

    toast.success("Request updated successfully!");
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to update request");
    return null;
  } finally {
    toast.dismiss(toastId);
  }
}

// =========================================================
// STUDENT: DELETE REQUEST
// =========================================================
export async function deleteRequest(requestId) {
  const toastId = toast.loading("Deleting request...");
  try {
    const response = await apiConnector(
      "DELETE",
      `${REQUEST_BASE_API}/${requestId}`,
      null,
      getAuthHeader()
    );

    toast.success("Request deleted successfully!");
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to delete request");
    return null;
  } finally {
    toast.dismiss(toastId);
  }
}

// =========================================================
// ADMIN: GET ALL REQUESTS
// =========================================================
export async function getAllRequestsAdmin() {
  try {
    const response = await apiConnector(
      "GET",
      ADMIN_GET_ALL_REQUESTS_API,
      null,
      getAuthHeader()
    );
    console.log("response.data",response.data)
    return response.data;
    
  } catch (error) {
    toast.error("Failed to fetch all requests");
    return null;
  }
}

// =========================================================
// ADMIN: APPROVE OR DISMISS REQUEST (WITH REASON)
// =========================================================
export async function respondToRequestAdmin(requestId, status, adminReason = "") {
  const toastId = toast.loading("Processing request...");
  try {
    const response = await apiConnector(
      "PUT",
      `${ADMIN_REQUEST_BASE_API}/${requestId}`,
      { status, adminReason }, // e.g., status: "approved" or "dismissed"
      getAuthHeader()
    );

    toast.success(`Request ${status} successfully!`);
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to process request");
    return null;
  } finally {
    toast.dismiss(toastId);
  }
}

// =========================================================
// ADMIN: DELETE ANY REQUEST (OVERRIDE)
// =========================================================
export async function deleteRequestAdmin(requestId) {
  const toastId = toast.loading("Deleting request...");
  try {
    const response = await apiConnector(
      "DELETE",
      `${ADMIN_REQUEST_BASE_API}/${requestId}`,
      null,
      getAuthHeader()
    );

    toast.success("Request deleted by Admin!");
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to delete request");
    return null;
  } finally {
    toast.dismiss(toastId);
  }
}